import React, { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { sandboxAccessControl } from '../access-control/sandboxAccess.configuration'

const SandboxPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SandboxPage" */
      '../pages/sandbox/SandboxPage'
    )
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// Sandbox is retailer-scoped (no site/store-config in the URL): opening the page
// must NOT force a banner pick — banner is chosen inside the provision modal and
// the table groups/filters client-side. `scopePicker` is still required (with
// `hiddenScopePicker`) because RetailerScopeWrapper is what mounts the header
// title target; without it the page header wouldn't render.
export const sandboxRouter = (
  <DomainRoute route="sandbox" accessControl={sandboxAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="sandbox"
        component={SandboxPage as ComponentType<any>}
        accessControl={sandboxAccessControl}
        scopePicker={{
          hiddenScopePicker: true,
          titles: ['sandboxDomain.pageTitle'],
        }}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
